<template>
  <v-layout>
    <v-flex xs12>
      <v-container grid-list-md fluid style="padding: 0;">
        <v-layout row wrap>
          <draggable
                  v-model="sortedLetters"
                  :disabled="disabled"
                  class="layout row wrap"
                  @change="changePosition"
          >
            <v-flex
                    v-for="letter in sortedLetters"
                    :key="letter.id"
                    xs6
                    sm4
                    md3
                    lg2
                    v-on:click="$emit('change', letter)"
                    class="item"
            >
              <v-card>
                <v-card-title primary-title>
                  <h3 class="display-3 text-md-center mb-0 no-wrap" style="width: 100%;">{{ letter.uppercase }} {{ letter.lowercase }}</h3>
                </v-card-title>
              </v-card>
            </v-flex>
          </draggable>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import draggable from 'vuedraggable'
import { REORDER_LETTERS } from '../store/mutation-types'
import { MOVE_LETTER } from '../store/action-types'
import mobileBrowser from 'detect-mobile-browser'

const IS_MOBILE = mobileBrowser(false).isAny()

export default {
  props: ['letters'],
  components: {
    draggable
  },
  computed: {
    sortedLetters: {
      get () {
        return this.letters
      },
      set (letters) {
        this.$store.commit(REORDER_LETTERS, letters)
      }
    },
    disabled () {
      if (IS_MOBILE) {
        return true
      }
      return this.$store.getters.isLoading
    }
  },
  methods: {
    async changePosition ({ moved }) {
      const { element, newIndex, oldIndex } = moved
      let position
      if (newIndex > oldIndex) {
        position = this.letters[newIndex - 1].position
      } else {
        position = this.letters[newIndex + 1].position
      }

      await this.$store.dispatch(MOVE_LETTER, { letter: element, position })
    }
  }
}
</script>

<style scoped>
  .item {
    cursor: pointer;
  }
  .item:hover {
    opacity: .7;
  }
</style>
